import React, { useEffect, useState } from 'react';
import { AssignableAssessment } from '@/services/PagesServices/OrganizationMemberActivityService';

interface Props {
  userId: string;
  assigning: boolean;
  fetchAssignable: (userId: string, search?: string) => Promise<AssignableAssessment[]>;
  onConfirm: (formId: number, dueDate: string | null) => void;
  onClose: () => void;
}

const AssignAssessmentModal: React.FC<Props> = ({
  userId,
  assigning,
  fetchAssignable,
  onConfirm,
  onClose,
}) => {
  const [assessments, setAssessments] = useState<AssignableAssessment[]>([]);
  const [selected, setSelected] = useState<number | ''>('');
  const [dueDate, setDueDate] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const body = document.body;
    const prev = body.style.overflow;
    body.style.overflow = 'hidden';
    const escHandler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', escHandler);
    return () => {
      body.style.overflow = prev;
      window.removeEventListener('keydown', escHandler);
    };
  }, [onClose]);

  useEffect(() => {
    let active = true;
    setLoading(true);
    fetchAssignable(userId).then((list) => {
      if (active) {
        setAssessments(list);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, [userId, fetchAssignable]);

  const handleSubmit = () => {
    if (typeof selected === 'number') onConfirm(selected, dueDate || null);
  };

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="omact-modal-overlay" onClick={onClose}>
      <div className="omact-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Assign assessment</h2>

        <label htmlFor="omact-assess-form">Assessment</label>
        <select
          id="omact-assess-form"
          value={selected}
          onChange={(e) => setSelected(e.target.value ? Number(e.target.value) : '')}
          disabled={loading || assigning}
        >
          <option value="">
            {loading ? 'Loading…' : assessments.length === 0 ? 'No assessments available' : 'Select an assessment'}
          </option>
          {assessments.map((a) => (
            <option key={a.id} value={a.id}>{a.title}</option>
          ))}
        </select>

        <label htmlFor="omact-assess-due">Due date (optional)</label>
        <input
          id="omact-assess-due"
          type="date"
          value={dueDate}
          min={today}
          onChange={(e) => setDueDate(e.target.value)}
          disabled={assigning}
        />

        <div className="omact-modal-actions">
          <button className="omact-btn-secondary" onClick={onClose} disabled={assigning}>Cancel</button>
          <button
            className="omact-btn-primary"
            onClick={handleSubmit}
            disabled={assigning || selected === '' || loading}
          >
            {assigning ? 'Assigning…' : 'Assign'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignAssessmentModal;
